/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedRisk
 */
export interface PatchedRisk {
  /**
   *
   * @type {number}
   * @memberof PatchedRisk
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  scenarios?: string | null;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  readonly createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  readonly updatedBy?: string;
  /**
   *
   * @type {Date}
   * @memberof PatchedRisk
   */
  readonly createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof PatchedRisk
   */
  readonly updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedRisk
   */
  readonly categories?: string;
  /**
   *
   * @type {number}
   * @memberof PatchedRisk
   */
  category?: number;
}

/**
 * Check if a given object implements the PatchedRisk interface.
 */
export function instanceOfPatchedRisk(value: object): value is PatchedRisk {
  return true;
}

export function PatchedRiskFromJSON(json: any): PatchedRisk {
  return PatchedRiskFromJSONTyped(json, false);
}

export function PatchedRiskFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedRisk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    title: json['title'] == null ? undefined : json['title'],
    description: json['description'] == null ? undefined : json['description'],
    scenarios: json['scenarios'] == null ? undefined : json['scenarios'],
    createdBy: json['created_by'] == null ? undefined : json['created_by'],
    updatedBy: json['updated_by'] == null ? undefined : json['updated_by'],
    createdAt: json['created_at'] == null ? undefined : new Date(json['created_at']),
    updatedAt: json['updated_at'] == null ? undefined : new Date(json['updated_at']),
    categories: json['categories'] == null ? undefined : json['categories'],
    category: json['category'] == null ? undefined : json['category'],
  };
}

export function PatchedRiskToJSON(
  value?: Omit<PatchedRisk, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'categories'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    title: value['title'],
    description: value['description'],
    scenarios: value['scenarios'],
    category: value['category'],
  };
}
